// Owner: engagements (owner feedback F19). The one way to log an activity or add a task from anywhere: a record's
// header, an object's list, Home, the Inbox, the command bar, a task. Light module (no dialog code): the dialogs load
// on first open (`src/overlays/engagements.tsx`).
import type { EngagementDTO } from '@dataroom/core/engagements';
import { openLayer } from '../../shell/overlays';

export type RecordLinkRequest = { objectKey: string; recordId: string; title?: string };

export type LogEngagementRequest = {
  /** The engagement type to start with (default `call`); the dialog offers the other types too. */
  type?: string;
  /** The records it is about (the first is the primary subject). */
  links?: RecordLinkRequest[];
  /** No record yet: start with a picker for this object (the quick action of an object's list). */
  objectKey?: string;
  /** The people it was with (records of any person-like object). */
  with?: RecordLinkRequest[];
  title?: string;
  /** When it happened or is planned (ISO instant; default now). */
  at?: string;
  /** The task this is logged from (a call task that was just made). */
  taskId?: string;
  onLogged?: (engagement: EngagementDTO) => void;
  /** Change this engagement instead of logging a new one. */
  existing?: EngagementDTO;
};

export type CreateTaskRequest = {
  context?: { objectKey: string; recordId: string };
  typeKey?: string;
  /** No record yet: start with a picker for this object. */
  objectKey?: string;
};

/** The record a message of one's own mailbox is put on. */
export type MailboxLinkRequest = { objectKey: string; recordId: string; title?: string };

declare module '../../shell/overlays' {
  interface GlobalLayers {
    'engagement-log': LogEngagementRequest;
    'task-create': CreateTaskRequest;
    'engagement-links': { engagement: EngagementDTO };
    'mailbox-link': MailboxLinkRequest;
  }
}

/** Open the dialog that logs a call, meeting, note or any engagement type. */
export function openLogEngagement(request: LogEngagementRequest = {}) {
  openLayer('engagement-log', request);
}
/** Open the dialog that adds a task (optionally about a record). */
export function openCreateTask(request: CreateTaskRequest = {}) {
  openLayer('task-create', request);
}
/** Open the dialog that changes the records an engagement is on (also a captured mail or meeting). */
export function openEngagementLinks(engagement: EngagementDTO) {
  openLayer('engagement-links', { engagement });
}
/** Open the picker that puts a message of one's own mailbox on a record. */
export function openMailboxLink(request: MailboxLinkRequest) {
  openLayer('mailbox-link', request);
}
